import { render, staticRenderFns } from "./TicketDetailsAgent.vue?vue&type=template&id=3849f16a&scoped=true&"
import script from "./TicketDetailsAgent.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsAgent.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailsAgent.vue?vue&type=style&index=0&id=3849f16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849f16a",
  null
  
)

export default component.exports